/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

import { _EuiThemeLevels } from '../../../../global_styling/variables';

export const levels: _EuiThemeLevels = {
  toast: 9000,
  modal: 8000,
  mask: 6000,
  navigation: 6000,
  menu: 2000,
  header: 1000,
  flyout: 1000,
  maskBelowHeader: 1000,
  content: 0,
};
